import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Contact } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';

// 30 minutes frontend cache for contact list query
const CACHE_TIME = 30 * 60 * 1000;

export const useContactsQuery = () => {
  return useQuery({
    queryKey: ['contacts'],
    queryFn: fetchContacts,
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
  });
};

const fetchContacts: QueryFunction<Contact[], [string]> = async () => {
  const accessToken = getAccessToken();
  const { data } = await axios.get<Contact[]>(API.endpoints.contacts, {
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
